import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { setTablaPlanesPago } from '../../../../actions'
import Swal  from 'sweetalert2';
import { guardarPlanPago, getPlanesPago } from '../../../../services/PlanesDePago';
import { alerta, toast, cerrarModal } from '../../../../services/utilities';

function Nuevo(props){

    const [lista_modalidades_juego, setListaModalidadesJuego] = useState();
    const [captionTablaModalidades, setCaptionTablaModalidades] = useState('');
    const [btn_guardar, setBtnGuardar] = useState(true);
    const [categoria_modalidad, setCategoriaModalidad] = useState('');
    const [sorteosPlan, setSorteosPlan] = useState([]);

    const [item_plan_pago, setItemPlanPago] = useState({
        "id_modalidad_juego":"",
        "valor": ""
    });

    const [plan, setPlan] = useState({
        "nombre": "",
        "item_plan_pago": [],
    });

    const handleInputPlan = (event) => {
        const { name, value } = event.target;
        setPlan({ ...plan, [name]: value });
    };

    const handleInputItemPlan = (event) => {
        const { name, value } = event.target;
        const siguienteItem = { ...item_plan_pago, [name]: value };
        setItemPlanPago(siguienteItem);

        if(name === 'id_modalidad_juego'){
            const modalidadSeleccionada = (props.listaModalidades || []).find(item => String(item.id_modalidad_juego) === String(value));

            if(modalidadSeleccionada?.nombre_categoria === 'SORTEOS'){
                setSorteosPlan([
                    {
                        numero_sorteo: '1',
                        valor: ''
                    }
                ]);
            }else{
                setSorteosPlan([]);
            }
        }
    };

    const handleInputCategoriaModalidad = (event) => {
        const { value } = event.target;
        setCategoriaModalidad(value);
        setItemPlanPago({ ...item_plan_pago, id_modalidad_juego: "" });
        setSorteosPlan([]);
    };

    const handleInputSorteoPlan = (index, name, value) => {
        const nuevosSorteos = [...sorteosPlan];
        nuevosSorteos[index] = {
            ...nuevosSorteos[index],
            [name]: value
        };
        setSorteosPlan(nuevosSorteos);
    };

    const handleTieneItemPendiente = () => {
        const tieneModalidadSeleccionada = item_plan_pago.id_modalidad_juego !== '';
        const tieneValorPendiente = item_plan_pago.valor !== '' && item_plan_pago.valor !== '0';
        const tieneSorteosPendientes = Array.isArray(sorteosPlan) && sorteosPlan.length > 0;

        return tieneModalidadSeleccionada || tieneValorPendiente || tieneSorteosPendientes;
    };

    const handleAgregarSorteoPlan = () => {
        if(sorteosPlan.length >= 10){
            alerta('Solo puede agregar hasta 10 sorteos','El limite maximo para el sub plan de sorteos es 10');
            return;
        }

        const ultimoNumero = sorteosPlan.reduce((maximo, item) => {
            const numero = parseInt(item.numero_sorteo, 10);
            return Number.isNaN(numero) ? maximo : Math.max(maximo, numero);
        }, 0);

        setSorteosPlan([
            ...sorteosPlan,
            {
                numero_sorteo: `${ultimoNumero + 1}`,
                valor: ''
            }
        ]);
    };

    const handleEliminarSorteoPlan = (index) => {
        const nuevosSorteos = sorteosPlan.filter((_, idx) => idx !== index);
        setSorteosPlan(nuevosSorteos);

        if(nuevosSorteos.length === 0){
            setItemPlanPago({
                "id_modalidad_juego":"",
                "valor": ""
            });
        }
    };

    const handleAgregarItem= () => {
        const modalidadSeleccionada = (props.listaModalidades || []).find(item => String(item.id_modalidad_juego) === String(item_plan_pago.id_modalidad_juego));
        const esSorteos = modalidadSeleccionada?.nombre_categoria === 'SORTEOS';

        if(plan.nombre == ''){
            alerta('El nombre del plan no debe estar vacío.','Por favor digite el nombre del plan');
            return;
        }else if(item_plan_pago.id_modalidad_juego == ''){
            alerta('Seleccione una modalidad de juego','Por favor seleccione una modalidad valida');
            return;
        }else if(!esSorteos && item_plan_pago.valor == ''){
            alerta('Debe digitar un valor igual o mayor a cero','Por favor digite un valor valido');
            return;
        }else if(esSorteos && sorteosPlan.length === 0){
            alerta('Debe agregar al menos un sorteo','Agregue minimo un sorteo con su valor correspondiente');
            return;
        }else if(esSorteos && sorteosPlan.some(item => item.numero_sorteo === '' || item.valor === '')){
            alerta('Debe digitar número y valor para cada sorteo','Complete todos los datos del sub plan de sorteos');
            return;
        }else if(esSorteos && new Set(sorteosPlan.map(item => item.numero_sorteo)).size !== sorteosPlan.length){
            alerta('No puede repetir números de sorteo','Cada sorteo debe tener un numero_sorteo unico');
            return;
        }else if(plan.item_plan_pago.find(item => item.id_modalidad_juego === item_plan_pago.id_modalidad_juego) !== undefined){
            alerta('La modalidad de juego ya esta agregada en la lista','Por favor seleccione otra modalidad');
            return;
        }

        if(esSorteos){
            Swal.fire({
                title: 'Agregar modalidad de sorteos',
                text: `Se agregarán ${sorteosPlan.length} sorteos a la modalidad ${modalidadSeleccionada?.nombre ?? ''}.`,
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, agregar'
            }).then((result) => {
                if(result.isConfirmed){
                    handleConfirmarAgregarItem(modalidadSeleccionada, esSorteos);
                }
            });
            return;
        }

        handleConfirmarAgregarItem(modalidadSeleccionada, esSorteos);
    }

    const handleConfirmarAgregarItem = (modalidadSeleccionada, esSorteos) => {

        const itemNuevo = esSorteos ? {
            ...item_plan_pago,
            valor: "0",
            sorteos: sorteosPlan.map(item => ({
                numero_sorteo: `${item.numero_sorteo}`,
                valor: `${item.valor}`
            }))
        } : item_plan_pago;

        const nuevo_plan = {
            ...plan,
            item_plan_pago: [...plan.item_plan_pago, itemNuevo],
        };

        setPlan(nuevo_plan);
        
        setItemPlanPago({
            "id_modalidad_juego":"",
            "valor": ""
        })
        setSorteosPlan([]);

        handleArmarBodyItems(nuevo_plan.item_plan_pago, nuevo_plan);
    }

    const handleNombreModalidad = (id_modalidad_juego) =>{
        const item_plan = props.listaModalidades.find(item => item.id_modalidad_juego == id_modalidad_juego);
        return item_plan.nombre;
    }

    const handleArmarBodyItems = (items, plan) =>{

        setListaModalidadesJuego(items.map((r, indice) => (
            <tr key={indice} id={'tr-item-'+indice}>
                <td>
                    <div><b>{handleNombreModalidad(r.id_modalidad_juego)}</b></div>
                    {Array.isArray(r.sorteos) && r.sorteos.length > 0 ?
                        <div className="mt-2">
                            {r.sorteos.map((sorteo, idx) => (
                                <div key={idx} className="small text-secondary">Sorteo #{sorteo.numero_sorteo}: <b>${sorteo.valor}</b></div>
                            ))}
                        </div>
                    : null}
                </td>
                <td>{Array.isArray(r.sorteos) ? '-' : r.valor}</td>
                <td>
                    <button 
                        type="button" 
                        className="btn btn-danger btn-sm" 
                        title="Eliminar item" 
                        onClick={() => handleDelteItem(indice,plan)}>
                        <i className="bi bi-trash"></i>
                    </button>
                </td>
            </tr>
        )));
        
        setCaptionTablaModalidades(items.length == 0 ? '' : 'd-none');
        setBtnGuardar(items.length == 0 ? true : false);

    }

    const handleDelteItem = (indice,plan) => {
        plan.item_plan_pago.splice(indice, 1);
        handleArmarBodyItems(plan.item_plan_pago, plan);
        setPlan(plan);
    }

    const handleRefrescarTablaPlanesPago = () => {

        getPlanesPago().then(response => {
            if(response.status === 200){
                props.setTablaPlanesPago(response.data.data)
            }else{
                alerta('No se cargo la tabla de planes de pago o no hay actualemente creadas',response.response.data.status_message??response.message,'warning');
            }
        });
    }

    const handleGuardarPlanPago = () => {
        if(handleTieneItemPendiente()){
            alerta('Hay un item pendiente por agregar','Antes de guardar debe agregar o limpiar el item de sorteo/modalidad que esta en edición');
            return;
        }

        Swal.fire({
            title: "¿ Esta seguro de guardar la información del Plan de Pagos ?",
            text: "Si esta seguro presione el boton Guardar de lo contrario Cancelar",
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Guardar'
        }).then((result) => {
            if (result.isConfirmed) {
                guardarPlanPago(plan).then(response => {
                    if(response.status == 201){
                        setPlan({"nombre": "","item_plan_pago":[]});
                        handleRefrescarTablaPlanesPago();
                        handleArmarBodyItems([], plan);
                        cerrarModal('modalNuevoPlan');
                        toast('¡ Perfecto !','Plan de pago creado exitosamente','success');
                    }else{
                        alerta('Se presento un error al intentar guardar el plan de pagos',response.response.data.status_message??response.message);
                    }
                });
            }
        });
    }

    const handleCancelarModal = () => {
        if(handleTieneItemPendiente()){
            alerta('Hay un item pendiente por agregar','Antes de cancelar debe agregar o limpiar el item de sorteo/modalidad que esta en edición');
            return;
        }

        cerrarModal('modalNuevoPlan');
    };

    const modalidadesDisponibles = (props.listaModalidades || []).filter(item => {
        const categoria = (item.nombre_categoria || '').toString().toUpperCase();
        return categoria !== 'BONO MILLONARIO' && categoria !== 'RIFA';
    });

    const categoriasModalidad = [...new Set(
        modalidadesDisponibles
            .map(item => item.nombre_categoria)
            .filter(Boolean)
    )].sort();

    const modalidadesFiltradas = modalidadesDisponibles.filter(item => {
        if(categoria_modalidad == ''){
            return !plan.item_plan_pago.some(planItem => planItem.id_modalidad_juego == item.id_modalidad_juego);
        }

        return item.nombre_categoria === categoria_modalidad && !plan.item_plan_pago.some(planItem => planItem.id_modalidad_juego == item.id_modalidad_juego);
    });

    const modalidadSeleccionada = modalidadesDisponibles.find(item => String(item.id_modalidad_juego) === String(item_plan_pago.id_modalidad_juego));
    const esModalidadSorteos = modalidadSeleccionada?.nombre_categoria === 'SORTEOS';

    return(
        <React.Fragment>
            <div className="modal fade" id="modalNuevoPlan" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="modalNuevoPlan" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="staticBackdropLabel">Crear Nuevo Plan de Pagos</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control" id="nombre" name="nombre" value={plan.nombre} onChange={handleInputPlan} />
                                        <label htmlFor="floatingName">Nombre Plan: <span className="text-danger">*</span></label>
                                    </div>
                                </div>
                            </div>
                            <h5 className="card-title text-left">Items:</h5>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-floating mb-3">
                                        <select className="form-select" id="nombre_categoria" value={categoria_modalidad} name="nombre_categoria" aria-label="State" onChange={handleInputCategoriaModalidad}>
                                            <option value="">-- Todas las categorias --</option>
                                            {categoriasModalidad.map(opcion => (
                                                <option key={opcion} value={opcion}>{opcion}</option>
                                            ))}
                                        </select>
                                        <label htmlFor="nombre_categoria">Categoría modalidad:</label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-floating mb-3">
                                        <select className="form-select" id="id_modalidad_juego" value={item_plan_pago.id_modalidad_juego} name="id_modalidad_juego" aria-label="State" onChange={handleInputItemPlan}>
                                            <option value="">-- Seleccion --</option>
                                            {modalidadesFiltradas.map(opcion => (
                                                <option key={opcion.id_modalidad_juego} value={opcion.id_modalidad_juego}>{opcion.nombre}</option>
                                            ))}
                                        </select>
                                        <label htmlFor="id_modalidad_juego">Modalidad de Juego: <span className="text-danger">*</span></label>
                                    </div>
                                </div>
                                {!esModalidadSorteos ?
                                    <div className="col-md-2">
                                        <div className="form-floating mb-3">
                                            <input type="number" className="form-control input-sm" value={item_plan_pago.valor} id="valor" name="valor" onChange={handleInputItemPlan}   />
                                            <label htmlFor="floatingName">Valor: <span className="text-danger">*</span></label>
                                        </div>
                                    </div>
                                : null}
                                <div className="col-md-2 pt-3">
                                    <button type="button" className="btn btn-success" onClick={handleAgregarItem}>Agregar</button>
                                </div>
                            </div>
                            {esModalidadSorteos && Array.isArray(sorteosPlan) && sorteosPlan.length > 0 ?
                                <div className="row mb-3">
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <b>{modalidadSeleccionada?.nombre}</b>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    {sorteosPlan.map((sorteo, index) => (
                                                        <div className="col-md-12 mb-3" key={index}>
                                                            <div className="row align-items-end">
                                                                <div className="col-md-4">
                                                                    <label className="form-label">Número sorteo</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={sorteo.numero_sorteo}
                                                                        onChange={(e) => handleInputSorteoPlan(index, 'numero_sorteo', e.target.value)}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label className="form-label">Valor</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={sorteo.valor}
                                                                        onChange={(e) => handleInputSorteoPlan(index, 'valor', e.target.value)}
                                                                    />
                                                                </div>
                                                                <div className="col-md-2">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-danger w-100"
                                                                        onClick={() => handleEliminarSorteoPlan(index)}
                                                                    >
                                                                        Quitar
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <button type="button" className="btn btn-sm btn-outline-success" onClick={handleAgregarSorteoPlan}>
                                                            Agregar sorteo
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            : null}
                            <div className="row p-3">
                                <table className="table table-sm table-hover table-borderless"style={{ width : "90%"}}>
                                    <caption className={captionTablaModalidades}>
                                        <h5 className='text-secondary text-center'>No hay modalidades agregadas</h5>
                                    </caption>
                                    <tbody>
                                        {lista_modalidades_juego}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" disabled={btn_guardar || handleTieneItemPendiente()} onClick={handleGuardarPlanPago}>Guardar</button>
                            <button type="button" className="btn btn-secondary" onClick={handleCancelarModal}>Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

const mapDispatchToProps  = {
    setTablaPlanesPago
};

const mapSateToProps = state => {

    return {
        listaModalidades: state.listaModalidades
    }
}

export default  connect(mapSateToProps, mapDispatchToProps)(Nuevo);
